export const selectValidItems = (list) => list.filter( item => item.path);

export const selectHiddenItems = (allItems, items) => {
  let visibleIds = items.map( item => item.id);

  return (selectValidItems(allItems)
    .filter( item => ! _.includes(visibleIds, item.id)));
};
